import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  editSection: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '38px',
    alignItems: 'center',
  },
  label: {
    marginBottom: '10px',
    color: '#949ea9',
    whiteSpace: 'pre-line',
    textTransform: 'capitalize',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '16px',
    color: '#000000',
  },
}));
